import { useTranslation } from "@coworker/locales";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./SafetyAlarm.module.css";
import FixaStatus from "@coworker/apprestructured/src/shared/wrappers/FixaStatus/FixaStatus";

function SafetyAlarm() {
  const { t } = useTranslation();

  return (
    <FixaStatus
      label={
        <FixaText textStyle="Heading.XS" className={styles["label"]}>
          {t("safetyAlarmString")}
        </FixaText>
      }
      variant="negative"
      small
    />
  );
}

export default SafetyAlarm;
